import React, { Component } from 'react'
import SerializeForm from 'form-serialize'
import PropTypes from 'prop-types'
import ReactRouterPropTypes from 'react-router-prop-types'
import { Redirect } from 'react-router'

import { connect } from 'react-redux'
import * as api from '../api/api'
import * as actions from '../actions'

// React Material Web Components
import { Grid, GridCell } from 'rmwc/Grid';
import { FormField } from 'rmwc/FormField';
import { TextField, TextFieldIcon } from 'rmwc/TextField';
import { Card } from 'rmwc/Card';

import { Typography } from 'rmwc/Typography';
import centaLogo from '../assets/images/centa-logo-new.png';
import { Button } from 'rmwc/Button';
import StatusMessage from '../util/StatusMessage'

class UserConfirmation extends Component {

  constructor(props) {
    super(props);
    this.state = {
      errorMsg: '',
      confirmOtp: '',
      buttonDisable: false,
      regenButtonDisable: false,
      genOTPCountError: '',
      genOtpCount: 0,
    }
  }

  onInputChange = evt => {
    this.setState({
      [evt.target.name]: evt.target.value
    })
  };

  handleconfirmOTP = (e) =>{
    e.preventDefault();
    const obj = {}
    this.setState({buttonDisable: true})
    if (this.state.confirmOtp === '') {
      return this.setState({errorMsg: 'OTP is required.', buttonDisable: false})
    }
    let  values = {
      'user_name': this.props.userName,
      'confirm_otp': this.state.confirmOtp
    } 
    api
      .confirmRegistration(values)
      .then((result) => {
        const { status, data, errors } = result
        if (status === 'error') {
          this.setState({ errorMsg: errors,buttonDisable: false})
        }
        if (status === 'success') {
          this.setState({ errorMsg: '' })
          obj.accessToken = result.headers.accessToken            
          
          obj.userName = data.userName
          obj.id = data.id
          obj.role = data.role
          this.props.userLogin(obj)
          this.props.onRedirectPostLogin(data.pwdChangeReqd)
        }
      })
      .catch((err) => {
        console.log(err)
        this.setState({ errorMsg: 'Error in confirmation', buttonDisable:false })
      })
  }

  handleRegenerateOTP = (e) =>{
    e.preventDefault();
    const obj = {}
    let otpGenCount
    otpGenCount = this.state.genOtpCount
    this.setState({errorMsg: '',regenButtonDisable: true})
    let  values = {
      'user_name': this.props.userName
    }
    if(this.state.genOtpCount > 2){
      return this.setState({genOTPCountError: 'You have exceeded maximum number of OTP regenerations allowed. Please contact team@centa.org',errorMsg: '',regenButtonDisable: false})
    } 
    api
      .regenerateOTP(values)
      .then((result) => {
        const { status, data, errors } = result
        if (status === 'error') {
          this.setState({ errorMsg: errors, regenButtonDisable: false})
        }
        if (status === 'success') {
          otpGenCount = otpGenCount + 1
          this.setState({ errorMsg: result.message,regenButtonDisable: false,genOtpCount: otpGenCount})
        }
      })
      .catch((err) => {
        console.log(err)
        this.setState({ errorMsg: 'Error in confirmation', buttonDisable:false })
      })
  }

  render() {
    return(
      <div>
        <GridCell>
          <FormField style={{width: '100%'}}>
            <div className="login_icon">
              <TextFieldIcon use="lock_outline"/>
            </div>
            <TextField fullwidth label="Confirm OTP" name="confirmOtp" className='user_name' onChange={this.onInputChange} value={this.state.confirmOtp} />
          </FormField>
        </GridCell> 
        <GridCell className='submit-button'>
          <FormField>
            <Button raised disable={this.state.buttonDisable} onClick={this.handleconfirmOTP}>Confirm OTP</Button>
          </FormField>
          <br/>
          <br/>
          <FormField>
            <Button raised disable={this.state.regenButtonDisable} onClick={this.handleRegenerateOTP}>Regenerate OTP</Button>
          </FormField>
           <br/><Typography use="caption">OTP is sent to your registered mobile number /email address(Non-Indian Users).</Typography>
           <StatusMessage error_msg = {this.state.errorMsg}/>
           <StatusMessage error_msg = {this.state.genOTPCountError}/>
        </GridCell>
        <GridCell className='sign-up-link'>
          <Typography use="subheading2">Back to <Typography use="body1" tag="a" href="/portal/signin">Sign In</Typography></Typography>
        </GridCell>
      </div>
    );
  }
}

function mapStateToProps() {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    userLogin: data => dispatch(actions.userLogin(data)),
    adminLogin: data => dispatch(actions.adminLogin(data)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserConfirmation)


// WEBPACK FOOTER //
// ./src/views/UserConfirmation.jsx